import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
setupInterceptorsTo(axios);


class SampleProfile
{
    public getSampleProfileBySavingPlanId = async (savingPlanId: number): Promise<number> =>
    {
        let url: string = `${proxyUrl}/sampleProfile/savingPlan/${savingPlanId}`;
        const req = await axios.get(url);
        return req.data;
    }
}

const SampleProfileService = new SampleProfile();
export default SampleProfileService;